import jApi from './jApi';

export default {
  getProfile() {
    const api = jApi.generateApi();
    return api.get('user/profile')
      .then(res => res.data.data);
  },

  getProfileR3() {
    const api = jApi.generateApi();
    api.defaults.headers.get.TokenType = 'jwt';
    return api.get('app/api/v2/pro/user/profile/r3')
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiProfile.js